<template>
	<div v-if="parent_data" class="element el-row-price" :class="{ 'can-change': is_editable }">
		<div class="price">
			<!-- <span class="price-icon"><icon file="tag" :size="16" /></span> -->
			<span class="price-label">{{ label }}</span>
			<span class="price-value" :style="{ width: price_width }">
				<div v-if="editable">
					<el-textarea v-if="editable" :parent_data="parent_data" :property="property" :editable="editable" />
					<span class="value-suffix">{{ suffix }}</span>
				</div>
				<div v-else>
					<span>{{ value_text }}</span>
					<span class="value-suffix">{{ suffix }}</span>
				</div>
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import number from "@/libs/number";
import ElTextarea from "@/components/study/editor/elements/el-textarea";

export default {
	name: "el-row-price",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			
		};
	},
	props: {
		label: {default: ""},
		suffix: {default: ""},
		editable: { default: false },
		format: { default: "number" },
		price_width: { default: "96px" },
	},
	computed: {
		...mapGetters([ ]),
		value_text: function () {
			let str = this.value;
			if (this.format == "number") str = number.format(this.value);
			// if (this.suffix) str += ' ' + this.suffix
			return str;
		}
	},
	methods: {
		
	},
	components: { ElTextarea }
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.el-row-price
	&.can-change
		.price
			.price-value
				color dark
	.price
		background-color #eee
		margin 4px 0 0 16px
		padding 0 0 0 12px
		line-height 32px
		border-radius 4px
		overflow hidden
		white-space nowrap
		.price-icon
			float left
			margin 0 8px 0 0
		.price-label
			color dark
		.price-value
			position absolute
			right 0
			top 0
			padding 0 16px
			width 110px
			height 100%
			text-align center
			font-weight 600
			background-color green
			color #fff
			&:before
				content ''
				position absolute
				left 0
				top 0
				width 0
				height 0
				border-style solid
				border-width 16px 0 16px 8px
				border-color transparent transparent transparent #eee
			.el-textarea
				position absolute
				left 16px
				right 16px
				top 4px
				line-height 24px
		.value-suffix
			position: absolute
			right -12px

</style>